import {
    LIST_BRANCH_TYPE_REQUEST,
    LIST_BRANCH_TYPE_SUCCESS,
    LIST_BRANCH_TYPE_FAIL,
    CREATE_BRANCH_TYPE_REQUEST,
    CREATE_BRANCH_TYPE_SUCCESS,
    CREATE_BRANCH_TYPE_FAIL,
    DETAIL_BRANCH_TYPE_REQUEST,
    DETAIL_BRANCH_TYPE_SUCCESS,
    DETAIL_BRANCH_TYPE_FAIL,
    UPDATE_BRANCH_TYPE_REQUEST,
    UPDATE_BRANCH_TYPE_SUCCESS,
    UPDATE_BRANCH_TYPE_FAIL,
    DELETE_BRANCH_TYPE_REQUEST,
    DELETE_BRANCH_TYPE_SUCCESS,
    DELETE_BRANCH_TYPE_FAIL
} from '../../constants/branch-types'

const initialState = {
    branchTypes: [],
    branchType: {},
    loading: false,
    error: null,
    pageable: {}
}

const branchTypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case LIST_BRANCH_TYPE_REQUEST:
            return {
                ...state,
                loading: true
            }
        case LIST_BRANCH_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                branchTypes: action.payload,
                pageable: action.pageable
            }
        case LIST_BRANCH_TYPE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case CREATE_BRANCH_TYPE_REQUEST:
            return {
                ...state,
                loadingCreate: true
            }
        case CREATE_BRANCH_TYPE_SUCCESS:
            return {
                ...state,
                loadingCreate: false,
                branchTypes: [...state.branchTypes, action.payload]
            }
        case CREATE_BRANCH_TYPE_FAIL:
            return {
                ...state,
                loadingCreate: false,
                error: action.payload
            }
        case DETAIL_BRANCH_TYPE_REQUEST:
            return {
                ...state,
                loadingDetail: true
            }
        case DETAIL_BRANCH_TYPE_SUCCESS:
            return {
                ...state,
                loadingDetail: false,
                branchType: action.payload
            }
        case DETAIL_BRANCH_TYPE_FAIL:
            return {
                ...state,
                loadingDetail: false,
                error: action.payload
            }
        case UPDATE_BRANCH_TYPE_REQUEST:
            return {
                ...state,
                loadingUpdate: true
            }
        case UPDATE_BRANCH_TYPE_SUCCESS:
            const branchType = action.payload
            const branchTypeId = action.branchTypeId
            const branchTypesUpdate = [...state.branchTypes]

            const index = branchTypesUpdate.findIndex(branchType => branchType.id === branchTypeId)
            branchTypesUpdate[index] = branchType

            return {
                ...state,
                loadingUpdate: false,
                branchTypes: branchTypesUpdate
            }
        case UPDATE_BRANCH_TYPE_FAIL:
            return {
                ...state,
                loadingUpdate: false,
                error: action.payload
            }
        case DELETE_BRANCH_TYPE_REQUEST:
            return {
                ...state,
                loadingDelete: true
            }
        case DELETE_BRANCH_TYPE_SUCCESS:
            const branchTypeIdDelete = action.payload
            const branchTypesDelete = [...state.branchTypes]

            const indexDelete = branchTypesDelete.findIndex(branchType => branchType.id === branchTypeIdDelete)
            branchTypesDelete.splice(indexDelete, 1)

            return {
                ...state,
                loadingDelete: false,
                branchTypes: branchTypesDelete
            }
        case DELETE_BRANCH_TYPE_FAIL:
            return {
                ...state,
                loadingDelete: false,
                error: action.payload
            }
        default:
            return state
    }
}

export default branchTypesReducer